import { Routes, Route } from 'react-router-dom'

import {
  IAPICodeDTO,
  IContinuousRoute,
  ISavedStateFilteredRoute
} from '$/types'

import SavedStateList from 'features/RiskManagement/Components/SavedStateList'
import { IQRAScenario } from 'features/RiskManagement/Assessments/Scenarios/types'

import States from './States'
import { TypeCode } from './TypeCode'
import { WISAssessmentStatusCode } from './WISAssessmentStatusCode'

export interface IQRAStateAndAssessmentCommonAttributes {
  // REVIEW: Convert to treat id as string?
  id: number
  name: string
  author: string
  dateCreated: string
  createdBy?: string
  modifiedBy?: string
}

export interface ISavedState extends IQRAStateAndAssessmentCommonAttributes {
  modelId: string
  baselineId: string
  dateModified?: string
  risks: {
    graphType: string
    items: Array<{
      id: number
      name: string
      values: Array<{
        key: string
        value: number
      }>
    }>
  }
  assessments: IStateAssessment[]
  savedStateContinuousRoutes: ISavedStateFilteredRoute[]
}

export interface IStateAssessment
  extends IQRAStateAndAssessmentCommonAttributes {
  savedStateId: string
  userId: string
  typeCode: TypeCode | 'Baseline' | 'WIS'
  statusCode: WISAssessmentStatusCode
  isPublished: boolean
  statusDescription: string
  remainingMinutesEstimation?: number
  counterState: number
  totalSegmentCount: number
  customQuery?: string
  customQueryJson?: string
  assessmentContinuousRoutes: IContinuousRoute[]
  assessmentRiskLevels: IAPICodeDTO[]
  assessmentClassLocations: IAPICodeDTO[]
  assessmentConsequenceLevels: IAPICodeDTO[]
  assessmentRiskModels: Array<{ riskModelId: string }>
  assessmentScenarios: IQRAScenario[]
  fromForecastYear: number
}

export interface IWisStateAssessment {
  id: string
  title: string
  totalSegmentCount: number
  counterState: number
  remainingMinutesEstimation?: number
  status?: string
}

const Assessments = () => {
  return (
    <Routes>
      <Route path='states/*' element={<States />} />
      <Route path='*' element={<SavedStateList />} />
    </Routes>
  )
}

export default Assessments
